











  import { Component, Vue } from 'vue-property-decorator';
  import { namespace } from 'vuex-class';
import TranslationService from './services/TranslationService';

  const Layout = namespace('layout')

  @Component({
    name: 'App'
  })
  export default class App extends Vue {
    @Layout.Mutation
    setWidth!: (width: number) => void

    @Layout.Mutation
    setHeight!: (height: number) => void

    async mounted() {
      this.onResize()
      const language = await TranslationService.getCurrentLanguage();
      if (language) {
        this.$vuetify.lang.current = language.shortcut
      }
    }

    onResize() {
      this.setWidth(window.innerWidth)
      this.setHeight(window.innerHeight)
    }
  }
